import React from 'react'
import { SButton } from './index.styled'
import { ISButton } from './types'

const OutlineButton:React.FC<ISButton> = ({text, handleClick, backgroundColor, textColor}) => {
    return (
        <SButton
            onClick={handleClick}
            backgroundColor={backgroundColor}
            textColor={textColor}
        >
            {text}
        </SButton>
    )
}

export default OutlineButton
